import { type TrainingApiGateway } from "@/modules/training/gateway/trainingApiGateway"
import { LoggerService } from "@modules/common/logger/loggerService"
import { ApiClient } from "@modules/core/api/client/apiClient"
import { TrainingItemDtoSchema, type TrainingItemDto } from "@modules/training/gateway/trainingDto"
import { defaultDateFormat } from "@modules/utils/dateUtils"

import dayjs from "dayjs"

export class TrainingApi implements TrainingApiGateway {
  private baseUrl = "/trainings"

  constructor(private api: ApiClient) {}

  async getTrainingContents(startDate: string, endDate: string) {
    const result = await this.api.get<TrainingItemDto[]>(this.baseUrl, {
      params: {
        date: dayjs(startDate).format(defaultDateFormat),
        endDate: dayjs(endDate).format(defaultDateFormat),
      },
    })

    return result.data.map((trainingContent) => {
      const result = TrainingItemDtoSchema.safeParse(trainingContent)
      if (!result.success) {
        throw new Error(`Invalid training content: ${JSON.stringify(result.error)}`)
      }
      return result.data
    })
  }

  async getTrainingContentDate(date: string) {
    const result = await this.api.get<TrainingItemDto[]>(this.baseUrl, {
      params: {
        date: dayjs(date).format(defaultDateFormat),
      },
    })
    return result.data.map((trainingContent) => LoggerService.parseApiDto(TrainingItemDtoSchema, trainingContent))
  }
}
